import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { hasPermission } from "@utils/Utils";

export const useEUMSMultiEndPointPermission = (
  endpointCodes: string[]
): boolean => {
  const serviceCode = "EUMS";
  const permissions = useSelector(
    (state: RootState) => state.permission.userPermissions
  );

  return endpointCodes.some((endpointCode) =>
    hasPermission(permissions, serviceCode, endpointCode)
  );
};
